import { render } from "./iOSViewComponent.vue?vue&type=template&id=02c38925&scoped=true"
import script from "./iOSViewComponent.vue?vue&type=script&lang=js"
export * from "./iOSViewComponent.vue?vue&type=script&lang=js"

import "./iOSViewComponent.vue?vue&type=style&index=0&id=02c38925&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c38925"]])

export default __exports__